module.exports = __webpack_public_path__ + "img/search-icon@2x.3a345e93.png";